import { icons } from '../../../../shared/icons';
import MuiGrid from '../../UI/MuiGrid/MuiGrid';

const MenijiGridProvider = ({
  data,
  loading,
  handleOpenDelete,
  handleRowClick,
}) => {
  const menuColumns = [
    {
      field: 'naziv',
      headerName: 'Naziv menija',
      width: 400,
    },
    {
      field: 'opcije',
      headerName: 'Opcije',
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => handleOpenDelete(e.id)}
        >
          {icons.DELETE_ICON}
        </span>
      ),
    },
  ];

  return (
    <div style={{ height: '500px', width: '80vw', marginTop: '10px' }}>
      <MuiGrid
        data={data}
        loading={loading}
        columns={menuColumns}
        onRowDoubleClick={(e) => handleRowClick(e)}
      />
    </div>
  );
};

export default MenijiGridProvider;
